import { DateInput, validateDateInput, ValidationFunction } from "basis";

/* 
  Note:
      We have a `validateOver18YearsOld` validation function in library/formValidation.js,
      but it doesn't work with the new Form.
*/
export const validateOver18YearsOld: ValidationFunction<typeof DateInput> = (
  value,
  props,
) => {
  const errors = validateDateInput(value, props);

  if (errors) {
    return errors;
  }

  const { day, month, year } = value;
  const birthday18 = new Date(
    Number(year) + 18,
    Number(month) - 1,
    Number(day),
  );

  if (birthday18 > new Date()) {
    return {
      field: "You must be 18+ years.",
    };
  }

  return null;
};
